var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSplitPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1,14.8v5.1c0,.4-.3.7-.8.7H6.6c-.4,0-.7-.3-.7-.8v-5.1c0-.4.3-.7.8-.7s.7.3.7.8v4.3s9.3,0,9.3,0v-4.3c0-.4.3-.7.8-.7s.8.3.8.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1,4.2v5.1c0,.4-.3.7-.8.7s-.7-.3-.7-.8v-4.3s-9.3,0-9.3,0v4.3c0,.4-.3.7-.8.7s-.7-.3-.7-.8v-5.1c0-.4.3-.7.8-.7h10.8c.4,0,.8.3.8.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1,12c0,.4-.3.7-.8.7H4.6c-.4,0-.7-.3-.7-.8s.3-.7.8-.7h14.8c.4,0,.8.3.8.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitPage);
export default __webpack_public_path__ + "static/media/split-page.d241d5f1661ba5ed8d5093018a5876a6.svg";
export { ForwardRef as ReactComponent };